var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"qs_right1"}},[_c('div',{staticClass:"cc-header"},[_vm._v("本学期共获得荣誉"),_c('span',[_vm._v(" "+_vm._s(_vm.honourCount)+" ")]),_vm._v("项")]),_c('div',{staticClass:"main-value",attrs:{"id":"honor_info"}})])}
var staticRenderFns = []

export { render, staticRenderFns }